export interface Banking {
	id: number
	content: string
	created_at?: any
	updated_at: string
	bank_name: string
	bank_account: string
	bank_branch: string
	bank_account_name: string
}

export interface Detail {
	id: number
	order_id: number
	item_type: string
	course_id: number | null
	app_store_id: number | null
	created_at: string
	updated_at: string
	price: number
	discount_amount: string
	final_price: string
	voucher: string | null
	referrer: string | null
}

export interface Order {
	user_id: number
	status: number
	code_order: string
	voucher: string | null
	referrer: string | null
	discount_code: string | null
	discount_amount: number
	final_amount: number
	updated_at: string
	created_at: string
	id: number
	detail: Detail[]
}

export interface Order_detail {
	id: number
	order_id: number
	item_type: string
	course_id: number | null
	app_store_id: number | null
	created_at: string
	updated_at: string
	price: number
	discount_amount: string
	final_price: string
	voucher: string | null
	referrer: string | null
}

export interface Item_info {
	id: number
	type: string
	slug: string
	name: string
	price: number
	discount_amount: number
	final_price: number
	image: string
	path_image?: string
	voucher: string | null
	referrer: string | null
}

export interface Course_info {
	name: string
	price: number
	id: number
	slug: string
	image: string
	path_image?: string
	discount_amount: number
	final_price: number
	voucher: string | null
	referrer: string | null
}

interface IAffiliateInfo {
	name: string
	commission_amount: number
}

interface IDiscount {
	code: string
	percentage: number
	amount: number
	affiliate: IAffiliateInfo
}

export interface ICheckout {
	banking: Banking
	order: Order
	order_detail: Order_detail[]
	item_info: Item_info[]
	success: boolean
	is_confirmed?: boolean
	discount?: IDiscount | null
	course_info?: Course_info[]
}

export const initialCheckout: ICheckout = {
	banking: {
		id: 0,
		content: "",
		created_at: "",
		updated_at: "",
		bank_name: "",
		bank_account: "",
		bank_branch: "",
		bank_account_name: "",
	},
	order: {
		user_id: 0,
		status: 0,
		code_order: "",
		voucher: null,
		referrer: null,
		discount_code: null,
		discount_amount: 0,
		final_amount: 0,
		updated_at: "",
		created_at: "",
		id: 0,
		detail: [],
	},
	order_detail: [],
	item_info: [],
	success: false,
	is_confirmed: false,
}
